<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex
        sm3
        pr-3
        v-for="key in Object.keys(this.settingsGroups).sort()"
        :key="key"
      >
        <access-settings-group
          :group="settingsGroups[key]"
          @change="onChange"
        ></access-settings-group>
      </v-flex>
    </v-layout>
    <slot></slot>
    <div v-if="debug">{{ settingsGroups }}</div>
    * Disabling an option from the Agent main access settings will disable and remove it from all staff members of this agent
  </v-container>
</template>

<script>
import AccessSettingsGroup from "./AccessSettingsGroup";

export default {
  name: "AccessSettingsEditor",
  components: {
    AccessSettingsGroup,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      debug: false
    };
  },
  methods: {
    onChange(group) {
      const updatedArray = [
        ...group,
        ...this.value
          .filter((item) => item.groupName != group[0].groupName)
          .map((item) => ({
            groupName: item.groupName,
            settingName: item.settingName,
            settingValue: item.settingValue,
          })),
      ];

      this.$emit("input", updatedArray);
    },
  },
  computed: {
    settingsGroups() {
      return this.value.reduce((group, item) => {
        group[item.groupName] = group[item.groupName] || [];
        group[item.groupName].push(item);
        return group;
      }, {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/agents/AccessSettingsEditor.vue